// libs
import { styled } from '@nykaa/ui-components';

// global components
import BaseImage from 'shared/components/Image';

// mixin
import { truncate } from 'shared/styles/mixin';

// constants
import { DWEB_MAX_WIDTH, COLORS, BASE_GUTTER_SPACE } from 'shared/styles/base';
import { MARGIN_RIGHT } from 'shared/components/AdPlatformWidgets/Desktop/constant';

// mixins
import { getColumnDimension } from 'shared/components/AdPlatformWidgets/Desktop/mixin';

export const Section = styled.div<{ numOfColumns: number }>`
  display: inline-block;
  max-width: ${DWEB_MAX_WIDTH}px;
  width: auto;
  margin: 0 ${MARGIN_RIGHT}px 10px 0;
  border-radius: 3px;
  text-align: center;
  line-height: 0;
  cursor: pointer;

  &.textOverImage {
    .desc {
      width: 100%;
      position: absolute;
      top: 0;
      text-align: left;
      color: #fff;
    }
  }

  ${({ numOfColumns }) => getColumnDimension(numOfColumns)}
`;

export const Title = styled.p<{ textColor: string }>`
  ${truncate}
  display: block;
  color: ${(props) => props.textColor};
  ${({ theme }) => theme.typography.type201};
  margin-top: ${BASE_GUTTER_SPACE}px;
  text-align: left;
`;

export const Info = styled.p<{ textColor?: string }>`
  display: block;
  ${({ theme }) => theme.typography.bodyLarge};
  margin-top: ${BASE_GUTTER_SPACE}px;
  text-align: left;
  ${({ textColor }) => `
        color: ${textColor ? textColor : COLORS.BLACK_64};
    `}
`;

export const ImagePlaceholder = styled.div<{
  bgColor: string;
  aspectRatio: number;
}>`
  display: inline-block;
  max-width: 100%;
  width: 100%;

  ${({ bgColor, aspectRatio }) => `
        background-color: ${bgColor};
        padding-top: ${100 / aspectRatio}%;
    `}
`;

export const Image = styled(BaseImage)`
  max-width: 100%;
`;
